/**
 * Lista dei breakpoint standard basati su min-width.
 * I nomi seguono la convenzione di Bootstrap/Tailwind.
 *
 * @type {Object<string, string>}
 */
const breakpoint = {
    xs: "(max-width: 319px)",
    s: "(min-width: 320px)",
    m: "(min-width: 650px)",
    l: "(min-width: 1200px)",
    xl: "(min-width: 1840px)",
};

export { breakpoint }
